import { Link } from 'react-router-dom'
import { Breadcrumbs } from '../components/Breadcrumbs'
import { WallpaperCard } from '../components/WallpaperCard'
import { WALLPAPERS } from '../data/articles'
import { CONTENTS, contentHref } from '../data/content'
import { SITE } from '../data/site'
import { useSeo } from '../hooks/useSeo'

export function DownloadsPage() {
  useSeo({
    title: 'இலவச பதிவிறக்கங்கள்',
    description: 'இலவச PDF மற்றும் மொபைல் வால்பேப்பர்கள் — தனிப்பட்ட பக்திப் பயன்பாட்டிற்கு.',
    path: '/downloads',
  })

  const pdfs = CONTENTS.filter((c) => c.pdfUrl)

  return (
    <div className="page-hero">
      <div className="container section">
        <Breadcrumbs items={[{ label: 'முகப்பு', to: '/' }, { label: 'பதிவிறக்கங்கள்' }]} />
        <div className="section-header">
          <h1>இலவச பதிவிறக்கங்கள்</h1>
          <p>உள்நுழைவு இல்லை. ஒரு கிளிக்கில் பதிவிறக்கம். தனிப்பட்ட பக்திப் பயன்பாட்டிற்கு மட்டும்.</p>
        </div>

        <section className="section--tight">
          <h2>PDF கோப்புகள்</h2>
          {pdfs.length === 0 ? (
            <div className="empty-state">PDF கோப்புகள் விரைவில் சேர்க்கப்படும்.</div>
          ) : (
            <div className="card-grid">
              {pdfs.map((item) => (
                <div key={item.id} className="content-card" style={{ cursor: 'default' }}>
                  <span className="content-card__meta">PDF</span>
                  <h3>{item.titleTa}</h3>
                  <p>{item.titleEn}</p>
                  <div className="btn-row">
                    <Link className="btn btn--outline" to={contentHref(item)}>
                      பக்கத்தைப் பார்
                    </Link>
                    <a
                      className="btn btn--primary"
                      href={item.pdfUrl}
                      download
                      onClick={() => {
                        const w = window as Window & { gtag?: (...args: unknown[]) => void }
                        w.gtag?.('event', 'pdf_download', { event_label: item.id })
                      }}
                    >
                      பதிவிறக்கு
                    </a>
                  </div>
                </div>
              ))}
            </div>
          )}
        </section>

        <section className="section--tight">
          <h2>மொபைல் வால்பேப்பர்கள் (9:16)</h2>
          <div className="card-grid card-grid--3">
            {WALLPAPERS.map((wp) => (
              <WallpaperCard key={wp.id} item={wp} />
            ))}
          </div>
        </section>

        <p className="disclaimer-inline">{SITE.usageNotice}</p>
      </div>
    </div>
  )
}
